<template>
    <el-drawer
      :model-value="showCategoryModal"
      @update:model-value="updateShowCategoryModal"
      direction="ltr"
      class="category-dialog"
      :close-on-click-modal="false"
    >
      <h5>{{ $t('navigation.more_categories') }}</h5>

      <div>
        <ul class="header__nav">
          <li class="current"> 
            <ul class="sub-menu" style="display: block;">
              <li v-for="category in extraCategories" :key="category.id">
                <a href="javascript:void(0)" @click="navigateToCategory(category)">
                  {{ category.name }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </el-drawer>
  </template>
  
  <script>
  import { defineComponent } from 'vue';
  import { useRouter } from 'vue-router';
  
  export default defineComponent({
    props: {
      showCategoryModal: Boolean,
      extraCategories: Array
    },
    emits: ['update:showCategoryModal', 'closeMenu'],
    setup(props, { emit }) {
      const router = useRouter();
      
      const updateShowCategoryModal = (value) => {
        emit('update:showCategoryModal', value);
      };
      
      const navigateToCategory = (category) => {
        console.log('Category clicked:', category.name);
        console.log('Current drawer state:', props.showCategoryModal);
        
        // First close the drawer
        emit('update:showCategoryModal', false);
        console.log('Emitted close event');
        
        // Emit close menu event
        emit('closeMenu');
        
        // Then navigate immediately
        console.log('About to navigate to:', `/category/${category.slug}`);
        router.push({ name: 'PostsPerCategoryPage', params: { slug: category.slug } }).then(() => {
          console.log('Navigation completed');
        }).catch(err => {
          console.error('Navigation failed:', err);
        });
      };
      
      return {
        updateShowCategoryModal,
        navigateToCategory
      };
    }
  });
  </script>
  